export const API_ENDPOINT =
	process.env.NODE_ENV !== 'production' ? 'http://localhost:5000/master' : 'https://api.msn.bet/master'
